import React, { useState, useEffect } from "react";

import { FaGlobe } from "react-icons/fa6";
import { FaCalendar } from "react-icons/fa6";
import { FaCloud } from "react-icons/fa6";
import { FaComputer } from "react-icons/fa6";
export default function AdhanFeature() {
  const [imageNumber, setImageNumber] = useState(1);
  const timeoutRef = React.useRef(null);

  const handleClick = (number) => {
    setImageNumber(number);
  };

  function resetTimeout() {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
  }

  useEffect(() => {
    resetTimeout();
    timeoutRef.current = setTimeout(
      () =>
        setImageNumber((prevIndex) => (prevIndex === 4 ? 1 : prevIndex + 1)),
      5000,
    );
    return () => {
      resetTimeout();
    };
  }, [imageNumber]);

  return (
    <div className="w-full md:h-lvh bg-[#2cd6b9] flex justify-center items-center pb-4">
      <div className="max-w-[1200px]">
        <h3 className="text-3xl font-bold col-span-3 px-2 py-4 text-white">
          Features
        </h3>
        <div className="grid grid-cols-1 md:grid-cols-2 py-4 px-2">
          <div>
            <div
              onClick={() => handleClick(1)}
              className="px-2 pt-2 cursor-pointer"
            >
              <div
                className={`${imageNumber === 1 ? "bg-gray-200" : "bg-white"} px-5 py-2 border h-full border-gray-200 rounded-lg shadow dark:bg-gray-800 dark:border-gray-700 overflow-hidden`}
              >
                <FaGlobe color="#D62C49" size={24} />
                <p className="text-xl font-semibold">
                  Multiple Place Prayer Times
                </p>
                <p>
                  Access accurate prayer timings for various locations
                  worldwide, ensuring you never miss a Salah no matter where you
                  are.
                </p>
              </div>
            </div>
            <div
              onClick={() => handleClick(2)}
              className="px-2 pt-2 cursor-pointer"
            >
              <div
                className={`${imageNumber === 2 ? "bg-gray-200" : "bg-white"} px-5 py-2 border h-full border-gray-200 rounded-lg shadow dark:bg-gray-800 dark:border-gray-700 overflow-hidden`}
              >
                <FaCalendar color="#D62C49" size={24} />
                <p className="text-xl font-semibold">
                  Tomorrow and Weekly Salah
                </p>
                <p>
                  Plan your day and week ahead with tomorrow's Salah timings and
                  a weekly overview, empowering you to manage your time
                  effectively.
                </p>
              </div>
            </div>
            <div
              onClick={() => handleClick(3)}
              className="px-2 pt-2 cursor-pointer"
            >
              <div
                className={`${imageNumber === 3 ? "bg-gray-200" : "bg-white"} px-5 py-2  border h-full border-gray-200 rounded-lg shadow dark:bg-gray-800 dark:border-gray-700 overflow-hidden`}
              >
                <FaCloud color="#D62C49" size={24} />
                <p className="text-xl font-semibold">iCloud Sync</p>
                <p>
                  Seamlessly synchronize prayer times across all your
                  iCloud-enabled devices for a consistent experience wherever
                  you go.
                </p>
              </div>
            </div>
            <div
              onClick={() => handleClick(4)}
              className="px-2 pt-2 cursor-pointer"
            >
              <div
                className={`${imageNumber === 4 ? "bg-gray-200" : "bg-white"} px-5  py-2 bg-white border h-full border-gray-200 rounded-lg shadow dark:bg-gray-800 dark:border-gray-700 overflow-hidden`}
              >
                <FaComputer color="#D62C49" size={24} />
                <p className="text-xl font-semibold">Multiple Device Support</p>
                <p>
                  Enjoy the convenience of accessing prayer times on all your
                  iOS, macOS, watchOS and visionOS devices, ensuring you stay
                  connected and informed wherever you are.
                </p>
              </div>
            </div>
          </div>
          <div className="flex items-center justify-center pt-[100px]">
            <img
              width={200}
              src={`/asset/adhan/screen/adhan-${imageNumber}.webp`}
              alt="List of City"
            />
          </div>
        </div>
      </div>
    </div>
  );
}
